import * as React from "react"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
import Stack from "@mui/material/Stack"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { BREADCRUMB_MAPPER, META_DATA_KEYS } from "../../util/StaticData"
import { createUseStyles, useTheme } from "react-jss"

const mapper: any = {
  "data-metadata": "Data Metadata",
  "model-metadata": "Model Metadata",
}
const useStyles = createUseStyles({
  wrapper: {},
})

export default function CustomBreadCrumb() {
  const theme: any = useTheme()
  const classes = useStyles({ theme })

  const [breadcrumbs, setBreadcrumbs]: any = React.useState([])
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  function handleClick(routeTo: string) {
    navigate(routeTo)
  }

  React.useEffect(() => {
    const pathnames = location.pathname.split("/").filter((x) => x)
    const breadcrumbItems = pathnames.map((value, index) => {
      const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`
      const isLast = index === pathnames.length - 1

      return isLast ? (
        <Typography
          key={mapper[value] ? mapper[value] : value}
          color="text.primary"
        >
          {mapper[value] ? mapper[value] : value}
        </Typography>
      ) : (
        <Link
          key={mapper[value] ? mapper[value] : value}
          underline="hover"
          color="inherit"
          onClick={() => handleClick(routeTo)}
          sx={{ cursor: "pointer" }}
          className={classes.wrapper}
        >
          {mapper[value] ? mapper[value] : value}
        </Link>
      )
    })

    // Include search parameters in the last breadcrumb
    const tab: any = searchParams.get("tab")
    if (tab) {
      if (META_DATA_KEYS[tab]) {
        breadcrumbItems.push(
          <Typography key="searchParams" color="text.primary">
            {META_DATA_KEYS[tab]}
          </Typography>,
        )
      } else if (BREADCRUMB_MAPPER[tab]) {
        breadcrumbItems.push(
          <Typography key="searchParams" color="text.primary">
            {BREADCRUMB_MAPPER[tab]}
          </Typography>,
        )
      } else {
        breadcrumbItems.push(
          <Typography key="searchParams" color="text.primary">
            {tab}
          </Typography>,
        )
      }
    }
    setBreadcrumbs(breadcrumbItems)
  }, [location, searchParams])

  return (
    <Stack spacing={2} sx={{ marginTop: 1.5, marginBottom: 1.5 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className={classes.wrapper}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  )
}
